import { useMemo } from "react";
import { useFilterSettingsStore, useMapStore } from "..";
import IEntityWithIcon from "../interfaces/IEntityWithIcon";
import ILeaseComp from "../interfaces/ILeaseComp";
import useVisibleLeaseCompsOnMap from "./useVisibleLeaseCompsOnMap";
import useVisibleOnMapCompanyIds from "./useVisibleOnMapCompanyIds";

export default function (): ILeaseCompWithIcon[] {
    const mapStore = useMapStore();
    const { filters: { companySettings: companyFilters } } = useFilterSettingsStore();
    const visibleOnMapCompanyIds = useVisibleOnMapCompanyIds();
    const leaseComps = useVisibleLeaseCompsOnMap();

    const companiesLeaseComps = useMemo(() =>
        companyFilters.includeLeaseComps
            ? leaseComps.filter((lc) => lc.pipedriveCompanyId && visibleOnMapCompanyIds.includes(lc.pipedriveCompanyId))
            : []
        , [leaseComps, visibleOnMapCompanyIds, companyFilters.includeLeaseComps]);

    return useMemo(() => companiesLeaseComps.map((lc) => {
        return {
            ...lc,
            icon: lc.pipedriveCompanyId && mapStore.loadedLogoCompanyIds.includes(lc.pipedriveCompanyId)
                ? `location-marker-company-${lc.pipedriveCompanyId}`
                : "lease-comp-marker",
        };
    }), [companiesLeaseComps, mapStore.loadedLogoCompanyIds]);
}

type ILeaseCompWithIcon = ILeaseComp & IEntityWithIcon